export default {
  SET_TASK_SCHEDULER: function (state, payloads) {
    state.taskSchedulers = payloads;
  }
}
